import { inject } from '@angular/core';
import { CanActivateFn, Router, type UrlTree } from '@angular/router';
import { map } from 'rxjs';
import { AuthStore } from './auth-store';

const DEFAULT_RETURN_URL = '/home';

/** Отсекает `//evil.com` и `/\evil.com`: браузеры трактуют их как protocol-relative URL. */
const INTERNAL_PATH = /^\/(?![/\\])[^\s\\]*$/;

/** Защита от open-redirect: `returnUrl` приходит из query-параметра, то есть от кого угодно. */
export function safeReturnUrl(url: string | null | undefined): string {
  return typeof url === 'string' && INTERNAL_PATH.test(url) ? url : DEFAULT_RETURN_URL;
}

/** UrlTree, а не `navigate()` + `false`: редирект обязан быть частью той же навигации. */
export const authGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthStore);
  const router = inject(Router);

  const check = (): true | UrlTree => {
    if (!auth.isAuthed()) {
      return router.createUrlTree(['/login'], {
        queryParams: { returnUrl: safeReturnUrl(state.url) },
      });
    }
    // Имя обязательно: с заказом работают курьер и оператор, безымянный клиент им бесполезен.
    if (auth.needsName()) {
      return router.createUrlTree(['/login/name'], {
        queryParams: { returnUrl: safeReturnUrl(state.url) },
      });
    }
    return true;
  };

  // Вход через Telegram ещё летит: `Login` на вход не реагирует, и гость застрял бы на вводе номера.
  return auth.telegramPending() ? auth.telegramSettled().pipe(map(check)) : check();
};
